export default "__VITE_ASSET__CsVJeRXu__"